<div class="tab-section">
    <div *ngIf='installedData.length > 0'>
    <div class="dropdown-select">
        <span class="division-label">Division:</span>
        <p-dropdown 
            [options]="dropDownData" 
            [(ngModel)]="selectedDivision" 
            optionLabel="label"
            optionValue="value"
            [autoDisplayFirst]="true"
            (onChange)="onDivisionChange()">
        </p-dropdown>
    </div>
    
    
    
    <p-table [value]="installedData" [scrollable]="true" scrollHeight="400px" id="StyleTable" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="header">
            <tr>
                <th>Division</th>
                <th>Section</th>
                <th>TLR#</th>
                <th>TLR Status</th>
                <th></th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td>{{row.division}}</td>
                <td>{{row.section}}</td>
                <td [ngClass]="row.cssClass">{{row.tlr}}</td>
                <td [ngClass]="row.cssClass">{{row.status}}</td>
                <td><a (click)="details(row)" class="link-underline">Details</a></td>
                <td><a (click)="airComplianceDetails(row.tlr, 'Insert')" class="link-underline">Assign to me</a></td>
            </tr>
        </ng-template>
    </p-table>
    </div>
    <div *ngIf="installedData.length == 0">
        <p class="messageTitle">There are no TLR's that have been AIR (Installed)</p>
</div>
</div>